export default "__VITE_ASSET__D2IA23qs__"